import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Form, Button, Badge, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getCheckingStatus } from '../../../actions/checkingActions'
import { getLeaveRequests, createLeaveRequest, cancelLeaveRequest } from '../../../actions/employmentActions'
import Loader from '../../../components/loaders/Loader'

export default function SDOntimeLink() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { connected, checking, summary } = useSelector(state => state.checking)
    const { leaveRequests, loading } = useSelector(state => state.employment)
    const [showModal, setShowModal] = useState(false)
    const [form, setForm] = useState({ type: 'vacation', startDate: '', endDate: '', reason: '' })

    useEffect(() => {
        dispatch(getCheckingStatus())
        dispatch(getLeaveRequests())
    }, [dispatch])

    const handleOpenSDOntime = () => {
        window.open('https://sdontime.smalldev.es', '_blank', 'noopener')
    }

    const handleSubmit = async () => {
        if (!form.startDate || !form.endDate) return
        const ok = await dispatch(createLeaveRequest(form))
        if (ok) {
            setShowModal(false)
            setForm({ type: 'vacation', startDate: '', endDate: '', reason: '' })
        }
    }

    const handleCancel = async (id) => {
        await dispatch(cancelLeaveRequest(id))
    }

    const statusVariant = (status) => status === 'approved' ? 'success' : status === 'rejected' ? 'danger' : 'warning'
    const statusLabel = (status) => status === 'approved' ? t('teacher.employment.approved') : status === 'rejected' ? t('teacher.employment.rejected') : t('teacher.employment.pending')

    if (loading && (!leaveRequests || leaveRequests.length === 0)) return <Loader />

    return (
        <Container className='my-3 p-5'>
            <Row>
                <Col>
                    <h3 className='fw-bold mb-1'>{t('teacher.employment.title')}</h3>
                    <p className='text-muted mb-4'>{t('teacher.employment.subtitle')}</p>
                </Col>
            </Row>

            <Row className='g-4'>
                <Col xs={12} md={6} xl={4}>
                    <Card className='border-0 shadow-sm rounded-4 h-100'>
                        <Card.Body className='p-4'>
                            <div className='d-flex align-items-center gap-3 mb-3'>
                                <div className='icon-circle bg-primary bg-opacity-10'>
                                    <img src="/images/calendar.svg" alt="checking" width={20} />
                                </div>
                                <h5 className='fw-bold mb-0'>{t('teacher.employment.todaychecking')}</h5>
                            </div>
                            {!connected
                                ? <p className='text-muted mb-3'>{t('teacher.checking.notConnected')}</p>
                                : (
                                    <>
                                        <div className='d-flex justify-content-between mb-2'>
                                            <span className='text-muted'>{t('teacher.employment.schedule')}</span>
                                            <span className='fw-semibold text-black'>{summary?.totalWorked || '0h 0m'}</span>
                                        </div>
                                        <div className='d-flex justify-content-between mb-3'>
                                            <span className='text-muted'>{t('teacher.checking.working')}</span>
                                            {checking && !checking.end
                                                ? <Badge bg='success' className='rounded-pill'>{t('teacher.checking.working')}</Badge>
                                                : <Badge bg='secondary' className='rounded-pill'>-</Badge>
                                            }
                                        </div>
                                    </>
                                )
                            }
                            <Button variant='primary' className='rounded-3 w-100' onClick={handleOpenSDOntime}>
                                {t('teacher.employment.opendontime')} <i className='fa-solid fa-arrow-up-right-from-square ms-1'></i>
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs={12} md={6} xl={4}>
                    <Card className='border-0 shadow-sm rounded-4 h-100'>
                        <Card.Body className='p-4'>
                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                <div className='d-flex align-items-center gap-3'>
                                    <div className='icon-circle bg-success bg-opacity-10'>
                                        <img src="/images/document.svg" alt="requests" width={20} />
                                    </div>
                                    <h5 className='fw-bold mb-0'>{t('teacher.employment.myrequests')}</h5>
                                </div>
                                <Button variant='primary' size='sm' className='rounded-3' onClick={() => setShowModal(true)}>
                                    {t('teacher.employment.newrequest')}
                                </Button>
                            </div>
                            {(leaveRequests || []).length > 0
                                ? (leaveRequests || []).map(r => (
                                    <div key={r._id} className='d-flex align-items-start justify-content-between p-2 mb-1 bg-light rounded-3'>
                                        <div>
                                            <p className='fw-semibold mb-0' style={{ fontSize: '13px' }}>
                                                {r.type === 'vacation' ? t('teacher.employment.requestvacation') : t('teacher.employment.requestabsence')}
                                            </p>
                                            <p className='text-muted mb-0' style={{ fontSize: '12px' }}>
                                                {r.startDate ? new Date(r.startDate).toLocaleDateString() : ''} - {r.endDate ? new Date(r.endDate).toLocaleDateString() : ''}
                                            </p>
                                        </div>
                                        <div className='d-flex align-items-center gap-1 flex-shrink-0 ms-2'>
                                            <Badge bg={statusVariant(r.status)} className='rounded-pill'>{statusLabel(r.status)}</Badge>
                                            {r.status === 'pending' && (
                                                <Button variant='link' size='sm' className='text-danger p-0' onClick={() => handleCancel(r._id)}>
                                                    <i className='fa-solid fa-xmark'></i>
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                ))
                                : <p className='text-muted'>{t('teacher.employment.norequests')}</p>
                            }
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs={12} md={6} xl={4}>
                    <Card className='border-0 shadow-sm rounded-4 h-100'>
                        <Card.Body className='p-4'>
                            <div className='d-flex align-items-center gap-3 mb-3'>
                                <div className='icon-circle bg-warning bg-opacity-10'>
                                    <img src="/images/document.svg" alt="documents" width={20} />
                                </div>
                                <div>
                                    <h5 className='fw-bold mb-0'>{t('teacher.employment.documents')}</h5>
                                    <p className='text-muted mb-0'>{t('teacher.employment.contracts')} · {t('teacher.employment.payslips')}</p>
                                </div>
                            </div>
                            <p className='text-muted'>{t('teacher.employment.sdontimedetail')}</p>
                            <Button variant='primary' className='rounded-3 w-100' onClick={handleOpenSDOntime}>
                                {t('teacher.employment.opendontime')} <i className='fa-solid fa-arrow-up-right-from-square ms-1'></i>
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('teacher.employment.newrequest')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className='mb-3'>
                        <Form.Label>{t('teacher.employment.requesttype')}</Form.Label>
                        <Form.Select style={{ borderRadius: '10px' }}
                            value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                            <option value='vacation'>{t('teacher.employment.requestvacation')}</option>
                            <option value='absence'>{t('teacher.employment.requestabsence')}</option>
                        </Form.Select>
                    </Form.Group>
                    <Row>
                        <Col>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t('teacher.employment.startdate')}</Form.Label>
                                <Form.Control type='date' style={{ borderRadius: '10px' }}
                                    value={form.startDate} onChange={e => setForm({ ...form, startDate: e.target.value })} />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t('teacher.employment.enddate')}</Form.Label>
                                <Form.Control type='date' style={{ borderRadius: '10px' }}
                                    value={form.endDate} onChange={e => setForm({ ...form, endDate: e.target.value })} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group>
                        <Form.Label>{t('teacher.employment.reason')}</Form.Label>
                        <Form.Control as='textarea' rows={3} style={{ borderRadius: '10px' }}
                            placeholder={t('teacher.employment.reasonplaceholder')}
                            value={form.reason} onChange={e => setForm({ ...form, reason: e.target.value })} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' className='rounded-3' onClick={() => setShowModal(false)}>
                        {t('global.cancel')}
                    </Button>
                    <Button variant='primary' className='rounded-3' onClick={handleSubmit} disabled={!form.startDate || !form.endDate}>
                        {t('teacher.employment.sendrequest')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}
